import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import InputMask from "react-input-mask";
import moment from "moment";
import React from "react";

const CustomDatePicker = (props) => {
  const fullMonths = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];

  // Format selected date as "MonthName,YYYY" (e.g., "January,2024")
  const handleChange = (date) => {
    props.handleChange({
      target: { 
        name: props.name, 
        value: date ? moment(date).format("MMMM,YYYY") : "" 
      }
    });
  };

  // Custom input to display "MonthName,YYYY" format
  const CustomInput = React.forwardRef(({ value, onClick }, ref) => (
    <div style={{ 
      display: 'flex', 
      width: '100%',
      position: 'relative'
    }}>
      <input
        style={{
          ...(props.readOnly ? 
            { background: "#E9ECEF", color: "rgb(158, 163, 167)" } : {}),
          width: '100%',
          padding: '0.375rem 2.5rem 0.375rem 0.75rem',
          fontSize: '1rem',
          lineHeight: 1.5,
          color: '#495057',
          backgroundColor: '#fff',
          border: '1px solid #ced4da',
          borderRadius: '0.25rem',
          transition: 'border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out',
          outline: 'none'
        }}
        onClick={onClick}
        ref={ref}
        value={value}
        readOnly={true} // Force read-only to prevent manual text entry
        placeholder={props.placeholderText || "Month,Year"}
      />
      <div 
        style={{
          position: 'absolute',
          right: '0.75rem',
          top: '50%',
          transform: 'translateY(-50%)',
          cursor: 'pointer',
          color: '#6c757d',
          fontSize: '1rem',
          backgroundColor: 'transparent',
          border: 'none',
          padding: '0',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '1.5rem',
          height: '1.5rem'
        }}
        onClick={(e) => {
          if (value) {
            e.stopPropagation();
            handleChange(null); // Clear selection
          } else {
            onClick(e); // Open picker
          }
        }}
      >
        {value ? '×' : '📅'}
      </div>
    </div>
  ));

  return (
    <DatePicker
      selected={props.value ? moment(props.value, "MMMM,YYYY").toDate() : null}
      onChange={handleChange}
      customInput={<CustomInput />}
      renderCustomHeader={({
        date,
        changeYear,
        changeMonth,
        decreaseMonth,
        increaseMonth,
        prevMonthButtonDisabled,
        nextMonthButtonDisabled,
      }) => (
        <div className="input-group input-group-sm input-group-calender">
          <div className="input-group-prepend">
            <button
              onClick={(e) => {
                e.preventDefault();
                decreaseMonth();
              }}
              disabled={prevMonthButtonDisabled}
              className="btn btn-outline-secondary"
              type="button"
            >
              {"<"}
            </button>
          </div>
        
          {/* Year Dropdown */}
          <select
            className="form-control text-center"
            value={date.getFullYear()}
            onChange={({ target: { value } }) => changeYear(value)}
          >
            {Array.from({ length: 100 }, (_, i) => (
              <option key={i} value={date.getFullYear() - 50 + i}>
                {date.getFullYear() - 50 + i}
              </option>
            ))}
          </select>
          <div className="input-group-append">
            <button
              onClick={(e) => {
                e.preventDefault();
                increaseMonth();
              }}
              className="btn btn-outline-secondary"
              disabled={nextMonthButtonDisabled}
            >
              {">"}
            </button>
          </div>
        </div>
      )}
      wrapperClassName={props.wrapperClassName}
      placeholderText="Month,Year"
      maxDate={props.maxDate}
      minDate={props.minDate}
      id={props.id}
      name={props.name}
      readOnly={props.readOnly}
      dateFormat="MMMM,yyyy" // Format for display
      showMonthYearPicker   // Restrict to month/year selection
      showPopperArrow={false}
      popperClassName="react-datepicker-popper"
    />
  );
};

export default CustomDatePicker;